const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnergiBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "energi",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140.9 162.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "f1417617-549d-40d0-83e5-86ad6f15869d",
    "data-name": "border",
    d: "M44.05,33S50.91,10.87,73.51,3.21c27.77-9.4,60.28,8.34,64.85,12.37s1.26,29.72-8.06,54.28c-8.87,23.38-34.48,23.92-34.48,23.92l4.87,43,21.82,1.88s-1.35,5.37-1.35,5.66,10,4.82,10.21,5.89-17.14,11.29-18.27,12.1-50.16-2.13-50.16-2.13l-4.78-10.46-34-4.6,21.38-7.45s8.3-6.84-19.73-25.62c-15.65-10.48-7.56-52.86-7.56-52.86H.5V33.31Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergiBorder);
export default __webpack_public_path__ + "static/media/energi-border.0740e685f294ee5643ea3630aa2d23ce.svg";
export { ForwardRef as ReactComponent };